export const AZURE_AD_AUTH_PATHS = 'https://login.microsoftonline.com/**';
